import React from "react";

import { faPlus } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";

import { IconButton } from "~/ui/legacyFellowIndex";

import styles from "./LeftToolbar.module.css";

export default function LeftToolbar(props: { openEventForm: () => void }) {
	return (
		<span className={styles.wrapper}>
			<IconButton
				title="Create"
				icon={faPlus}
				onClick={props.openEventForm}
				variant="secondary"
				className={styles.button}
			/>
		</span>
	);
}
